import React from 'react';
import Waveform from 'react-audio-waveform';
import axios from 'axios';

export default class AudioWaveform extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			waveform: {}
		};
	}

	async componentDidMount() {
		let waveform = await axios.get(this.props.url, {withCredentials: true});
			
			this.setState({waveform: waveform.data});
	}

	render() {
		return (
			<div style={{position: 'relative', width: '90%', height: this.props.height, border: '1px solid #bbbbbb', borderRadius: 2, boxShadow: '5px 5px 5px #bbbbbb', marginTop: 20}}>
				{Object.keys(this.state.waveform).length > 0 &&
					<Waveform
						barWidth={this.props.barWidth}
						peaks={this.state.waveform.data}
						height={this.props.height}
						color={this.props.color}
						progressGradientColors={this.props.progressGradientColors}
					/>
				}
			</div>
		)
	}

}


